import validate from "/Users/pramos/Documents/repositories/bvb_contractors/node_modules/.pnpm/nuxt@4.4.8_@babel+plugin-proposal-decorators@7.28.0_@babel+core@7.29.7__@babel+plugin-s_e2eb9020c3576dd4fdd816534d9f0319/node_modules/nuxt/dist/pages/runtime/validate.js";
import session_45global from "/private/tmp/bvgci-published-order-production.I0Xvcn/app/middleware/session.global.ts";
import manifest_45route_45rule from "/Users/pramos/Documents/repositories/bvb_contractors/node_modules/.pnpm/nuxt@4.4.8_@babel+plugin-proposal-decorators@7.28.0_@babel+core@7.29.7__@babel+plugin-s_e2eb9020c3576dd4fdd816534d9f0319/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  session_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}